module.exports = __webpack_public_path__ + "static/img/blur_bg@2x.8ef7a0fa.8bc9088.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/blur_bg@2x.8ef7a0fa.jpg
// module id = hsbi
// module chunks = 0